
import React from 'react';

type TestimonialProps = {
  text: string;
  author: string;
  position: string;
  company?: string;
  rating?: number;
}

const TestimonialItem: React.FC<TestimonialProps> = ({ 
  text, 
  author, 
  position,
  company,
  rating = 5 
}) => {
  return (
    <div className="glass-card p-6 md:p-8 h-full hover-scale">
      <div className="flex flex-col h-full justify-between">
        <div>
          <div className="flex mb-6">
            {Array.from({ length: 5 }).map((_, i) => (
              <svg
                key={i}
                width="20"
                height="20"
                className={`${i < rating ? 'text-yellow-400 fill-current' : 'text-gray-300 fill-current'}`}
                viewBox="0 0 24 24"
                aria-hidden="true"
              >
                <path d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z" />
              </svg>
            ))}
          </div>
          <p className="text-gray-600 italic mb-4">"{text}"</p>
        </div>
        <div>
          <h4 className="font-semibold">{author}</h4>
          <p className="text-sm text-gray-500">
            {position}{company && ` at ${company}`}
          </p>
        </div>
      </div>
    </div>
  );
};

export default TestimonialItem;
